"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var setClauseValue_1 = require("../actions/setClauseValue");
var getCustomIcon_1 = require("../actions/helpers/getCustomIcon");
var mobx_react_1 = require("mobx-react");
var Icon_1 = require("office-ui-fabric-react/lib/components/Icon");
var Dropdown_1 = require("office-ui-fabric-react/lib/Dropdown");
var owa_mail_strings_1 = require("owa-strings/owa-mail-strings");
var React = require("react");
var store_1 = require("../store/store");
var styles = require('./InboxRuleClause.scss');
var InboxRulesFolderDropdown = /** @class */ (function (_super) {
    tslib_1.__extends(InboxRulesFolderDropdown, _super);
    function InboxRulesFolderDropdown() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InboxRulesFolderDropdown.prototype.render = function () {
        var _this = this;
        var currentSelectedFolder = store_1.default.inboxRulesEditState.clauseMap.get(this.props.clauseId)
            .clauseValue;
        var selectedKey = currentSelectedFolder ? currentSelectedFolder.folderId : null;
        return (React.createElement(Dropdown_1.Dropdown, { onFocus: this.props.onFocus, onBlur: this.props.onBlur, className: styles.moveToDropdown, options: this.getDropdownOptions(), onRenderOption: this.onRenderOption, onRenderTitle: function (options) { return _this.onRenderOption(options[0]); }, onChanged: function (item) { return setClauseValue_1.default(item.data.folder, _this.props.clauseId); }, placeHolder: owa_mail_strings_1.default.ruleSelectFolder, selectedKey: selectedKey }));
    };
    InboxRulesFolderDropdown.prototype.getDropdownOptions = function () {
        var dropdownOptions = [];
        this.props.dropdownFolderList.forEach(function (folder) {
            dropdownOptions.push({
                key: folder.folderId,
                text: folder.displayName,
                data: {
                    folder: folder,
                    icon: getCustomIcon_1.default(folder.folderId, true),
                },
            });
        });
        return dropdownOptions;
    };
    // Render dropdown items and current selection, which consist of icon and foldername
    InboxRulesFolderDropdown.prototype.onRenderOption = function (option) {
        return (React.createElement("div", { className: styles.dropdownItem },
            option.data &&
                option.data.icon && (React.createElement(Icon_1.Icon, { className: styles.customIcon, iconName: option.data.icon })),
            React.createElement("span", null, option.text)));
    };
    InboxRulesFolderDropdown = tslib_1.__decorate([
        mobx_react_1.observer
    ], InboxRulesFolderDropdown);
    return InboxRulesFolderDropdown;
}(React.Component));
exports.default = InboxRulesFolderDropdown;
//# sourceMappingURL=InboxRulesFolderDropdown.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/components/InboxRulesFolderDropdown.js
// module id = 5186
// module chunks = 2